import { type ReactNode } from 'react';

import { type IChipsOption } from '../IChipsOption';

/**
 * @description Класс для создания опции для чипов
 * @param label - Текст опции
 * @param value - Значение опции
 * @example
 * const chipsOption = new ChipsOption('2021');
 * console.log(chipsOption.label); // '2021'
 * console.log(chipsOption.value); // '2021'
 */
export class ChipsOption implements IChipsOption {
  public readonly label: string;
  public readonly value: string;
  public readonly leftIcon?: ReactNode;

  public constructor(label: string, value = label, leftIcon?: ReactNode) {
    this.label = label;
    this.value = value;

    if (leftIcon) {
      this.leftIcon = leftIcon;
    }
  }
}
